import { Id, TextField } from "@dgs/core";
import { ReactNode } from "react";
import {
	ContactAttributeRequest,
	IContactAttributeBaseHandler,
	IContactAttributeHandler,
	IContactAttributeListHandler,
} from "../IContactAttributeHandler";

export function createFirstNameContactAttributeBaseHandler(id: Id): IContactAttributeBaseHandler {
	return {
		type: "FIRST_NAME",
		id,
		getLabel: (t) => t("Firstname"),
	};
}

export function createFirstNameContactAttributeProfileHandler(
	id: Id,
	value: string | null,
): IContactAttributeHandler<string, string | null> {
	const baseHandler = createFirstNameContactAttributeBaseHandler(id);
	return {
		...baseHandler,
		value,
		validate() {
			return null;
		},
		renderValue(): ReactNode {
			return this.value ?? "";
		},
		renderFormField(t, prefix): ReactNode {
			return <TextField name={`${prefix ? `${prefix}.` : ""}${id}.value`} label={baseHandler.getLabel(t)} />;
		},
		toRequestValue(): ContactAttributeRequest<string> {
			return { id, value: this.value ?? "" };
		},
	};
}

export function createFirstNameContactAttributeListHandler(id: Id): IContactAttributeListHandler {
	const baseHandler = createFirstNameContactAttributeBaseHandler(id);
	return {
		...baseHandler,
		getColumnSize: () => "1fr",
	};
}
